<template>
    <div class="container">
        <b-modal
            :model-value="modEditarTasa"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-3">
                    <div class="password-policy-title">
                        {{ labels.formInfoTitle }}
                    </div>
                    <div class="password-policy-item">
                        {{ labels.formInfoSubtitle }}
                    </div>
                </div>
                <b-col md="4" lg="12" class="p-0 mx-auto">
                    <b-form-group>
                        <label>{{ labels.tipoTasa }}</label>
                        <b-form-select v-model="form.tipo_tasa" class="reset-input" autocomplete="off">
                            <option value="">{{ labels.select }}</option>
                            <option v-for="tipoTasa in listTipoTasa" :key="tipoTasa.id" :value="tipoTasa.tipo_tasa">{{ tipoTasa.descripcion }}</option>
                        </b-form-select>

                        <label>{{ labels.valor }}</label>
                        <b-form-input
                            v-model="form.valor"
                            type="number"
                            class="reset-input"
                        ></b-form-input>

                        <label>{{ labels.vigencia }}</label>
                        <b-form-input
                            v-model="form.vigencia"
                            type="date"
                            class="reset-input"
                        ></b-form-input>                        
                    </b-form-group>
                    <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                        <b-button
                            class="reset-btn-delete me-auto"
                            @click="eliminaRegistro()"
                        >
                            {{ labels.delete }}
                        </b-button>
                        <b-button
                            class="mr-2 reset-btn-secondary"
                            @click="cierraModal()"
                        >
                            {{ labels.close }}
                        </b-button>
                        <b-button
                            class="reset-btn-primary"
                            @click="guardarTasa()"
                        >
                            {{ labels.save }}
                        </b-button>
                    </div>
                </b-col>
            </div>
        </b-modal>
        <InacticaItem :InactivaItem="deleteTasa" @confirmDelete="confirmInactivate" @cierraModal="cierraModalDelet"/>
    </div>
</template>

<script>

import TipoTasas from '../../../services/TipoTasas' 
import Tasa from '../../../services/Tasas'; 
import InacticaItem from '../../utils/InacticaItem.vue'; 

export default {
    name : 'Editar',
    components : {InacticaItem},
    props: {
        modEditarTasa: {
            type: Boolean,
            required: true
        },
        infoTasa: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            form: {
                id: null,
                tipo_tasa: "",
                valor: "",
                vigencia: "",
            },
            listTipoTasa : [],
            deleteTasa: false,
            idTasa: null
        };
    },
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Editar tasa',
                    delete : 'Eliminar',
                    save : 'Guardar',
                    close : 'Cerrar',
                    select : 'Seleccione...', 
                    tipoTasa : 'Tipo tasa',
                    valor : 'Valor',
                    vigencia : 'Vigencia',
                    formInfoTitle: "Datos de la tasa",
                    formInfoSubtitle: "Actualiza la información de la tasa y guarda los cambios."
                }
            }else{
                return {
                    title : 'Edit rate',
                    delete : 'Delete',
                    save : 'Save',
                    close : 'Close',
                    select : 'Select...', 
                    tipoTasa : 'Rate type',
                    valor : 'Worth',
                    vigencia : 'Validity',
                    formInfoTitle: "Rate details",
                    formInfoSubtitle: "Update the rate information and save the changes."
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false) 
        },
        cierraModalDelet(){
            this.deleteTasa = false 
        },
        guardarTasa(){

            if (!this.form.tipo_tasa || !this.form.valor || !this.form.vigencia) {
                this.$toast.error("Campo(s) pendiente(s) por diligenciar");
                return;
            }

            const info = {
                id : this.form.id, 
                tipo_tasa : this.form.tipo_tasa, 
                valor : this.form.valor, 
                vigencia : this.form.vigencia, 
                idUser : this.$store.state.userId 
            }

            Tasa.updateTasaById(info) 
            .then((res) => { 
                if(res.status == 200){ 
                    this.$toast.success(res.data.message) 
                    this.$emit("actualizado");
                    this.cierraModal();
                }
            })
            .catch((error) => { console.log(error) })
        },
        eliminaRegistro(){
            this.idTasa = this.form.id 
            this.deleteTasa = true 
        },
        confirmInactivate(){
            Tasa.deleteTasa(this.idTasa) 
            .then((res) => { 
                if(res.status == 200){ 
                    this.$toast.success(res.data.message) 
                    
                    this.$emit("eliminado");
                    this.cierraModalDelet();
                    this.cierraModal(); 
                }
            })
            .catch((error) => error) 
        },
        nameTipoTasa(tipTasa){
            // console.log(tipTasa); 
            let name = this.listTipoTasa.find((tipoTasa) => tipoTasa.tipo_tasa == tipTasa) 
            // console.log(name); 
            return name?.descripcion 
        }
    },
    mounted(){
        TipoTasas.getAllTipoTasas() 
        .then((res) => { 
            // console.log(res.data.listTipoTasas); 
            this.listTipoTasa = res.data.listTipoTasas 
        })
        .catch((err) => { console.log(err) }) 
    },
    watch: {
        infoTasa: {
            immediate: true,
            deep: true,
            handler(value) {
                if (value) {
                    this.form = { ...value };
                }
            }
        }
    },
}
</script>

<style>

</style>
